var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoKidsProtection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2512_292)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.988 495.056C876.096 763.937 600.16 946.642 353.148 842.138C165.281 764.166 74.6869 540.168 155.807 353.747C246.359 140.291 508.146 63.322 702.19 187.679C806.225 252.666 873.884 371.867 873.967 495.056H873.988ZM852.513 495.056C854.35 377.253 795.769 260.494 698.643 193.003C511.089 60.5872 245.295 143.903 160.899 355.855C86.0607 537.893 177.323 752.893 360.16 825.207C593.502 920.36 851.198 746.693 852.492 495.056H852.513Z",
    fill: "#AC9235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.656 328C409.082 328 420.04 332.53 428.119 340.594C436.198 348.658 440.737 359.596 440.737 371C440.737 382.404 436.198 393.342 428.119 401.406C420.04 409.47 409.082 414 397.656 414C386.23 414 375.273 409.47 367.193 401.406C359.114 393.342 354.575 382.404 354.575 371C354.575 359.596 359.114 348.658 367.193 340.594C375.273 332.53 386.23 328 397.656 328ZM349.19 650.5V596.75H337.208C329.871 596.75 324.688 589.561 326.977 582.573L347.911 519.82L328.66 545.217C321.457 554.691 307.927 556.505 298.503 549.383C289.079 542.261 287.194 528.756 294.33 519.283L333.977 467.078C349.056 447.191 372.683 435.5 397.656 435.5C422.63 435.5 446.257 447.191 461.335 467.078L500.983 519.283C508.185 528.756 506.3 542.261 496.809 549.383C487.318 556.505 473.788 554.691 466.653 545.217L447.401 519.82L468.336 582.573C470.692 589.561 465.441 596.75 458.104 596.75H446.122V650.5C446.122 662.392 436.496 672 424.582 672C412.667 672 403.041 662.392 403.041 650.5V596.75H392.271V650.5C392.271 662.392 382.645 672 370.731 672C358.816 672 349.19 662.392 349.19 650.5ZM613.06 328C624.486 328 635.443 332.53 643.523 340.594C651.602 348.658 656.141 359.596 656.141 371C656.141 382.404 651.602 393.342 643.523 401.406C635.443 409.47 624.486 414 613.06 414C601.634 414 590.676 409.47 582.597 401.406C574.518 393.342 569.979 382.404 569.979 371C569.979 359.596 574.518 348.658 582.597 340.594C590.676 332.53 601.634 328 613.06 328ZM607.675 586V650.5C607.675 662.392 598.049 672 586.134 672C574.22 672 564.594 662.392 564.594 650.5V529.898L555.911 543.672C549.583 553.75 536.255 556.706 526.225 550.391C516.196 544.075 513.166 530.772 519.494 520.761L554.295 465.6C566.142 446.855 586.808 435.433 608.954 435.433H617.233C639.447 435.433 660.112 446.788 671.892 465.6L706.693 520.828C713.021 530.906 709.992 544.142 699.962 550.458C689.932 556.773 676.604 553.75 670.277 543.739L661.526 529.898V650.5C661.526 662.392 651.9 672 639.985 672C628.071 672 618.445 662.392 618.445 650.5V586H607.675Z",
    fill: "#AC9235"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint0_linear_2512_292)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "url(#paint1_linear_2512_292)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2512_292",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.15
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2512_292",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2512_292"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1000,
    height: 1000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoKidsProtection);
export default __webpack_public_path__ + "static/media/Logo_KidsProtection.988c473d05f720da78d8ba775f53c6bc.svg";
export { ForwardRef as ReactComponent };